import type { FunctionComponent } from 'react';

type HardSkillIconProps = {
    readonly isActive: boolean;
};

export const HardSkillIcon: FunctionComponent<HardSkillIconProps> = ({ isActive }: HardSkillIconProps) => {
    return (
        // biome-ignore lint/a11y/noSvgWithoutTitle: suppressed due to migration
        <svg fill="none" height="12" viewBox="0 0 12 12" width="12" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M11.7644 10.8376C11.8694 11.0214 11.7367 11.25 11.5251 11.25H0.474938C0.263313 11.25 0.130639 11.0214 0.235635 10.8376L5.7607 1.16878C5.86651 0.983616 6.13349 0.983616 6.2393 1.16878L11.7644 10.8376Z"
                fill={isActive ? '#FC531F' : '#1D272D'}
            />
        </svg>
    );
};
